export default "__VITE_ASSET__BIsvlD6z__"